<!-- <p>admin-usergroup works!</p> -->
<div class="main-panel">
    <div class="d-flex">
        <div class="d-flex pt-2">
            <div class="h-30p">
                <input
                    type="text"
                    class="form-control text-box-size shadow-sm client-search-input"
                    placeholder="Search"
                    [attr.id]="'gyan-mks-textbox'"
                    [attr.data-test]="'gyan-mks-textbox'"
                    [(ngModel)]="siteNameFilter"
                    (keyup.enter)="applyFilter()"
                    (input)="onClearLoad()"
                />
                <div
                    class="cursor-pointer clear-icon icon-pos"
                    [attr.id]="'clear-search-mks'"
                    [attr.data-test]="'clear-search-mks'"
                    (click)="clearSearch()"
                    *ngIf="siteNameFilter !== ''"
                ></div>
            </div>

            <div class="form-control search-client"></div>

            <div class="cursor-pointer search-term-icon" [attr.id]="'apply-filter-mks'" [attr.data-test]="'apply-filter-mks'" (click)="applyFilter()"></div>
        </div>

        <div class="d-flex" class="submit-button pt-2">
            <button
                class="create-button d-flex"
                #createButton
                [attr.id]="'create-site-mks'"
                [attr.data-test]="'create-site-mks'"
                (click)="openSiteCreationForm(SiteCreateAndEditModel)"
            >
                <div class="icon-plus"></div>
                <div class="pl-5p">Create Site</div>
            </button>
        </div>
    </div>

    <div class="table-container" #wrapper style="height: 410px; overflow-y: auto; position: relative">
        <table class="custom-table" [ngClass]="{ 'custom-table-loading': isLoadingData }">
            <thead class="custom-table-head-user">
                <tr>
                    <th class="col-2">Site Id</th>
                    <th class="col-3">Site Name</th>
                    <th class="col-2">Visibility</th>
                    <th class="col-3">Description</th>
                    <th class="col-2 actions-text">Action</th>
                </tr>
            </thead>
            <tbody #rows>
                <ng-container *ngIf="!isLoadingData">
                    <tr class="h-20p" *ngFor="let mks of visibleMksList; let i = index" class="h-30p">
                        <td>
                            <div class="display-ellipsis" title="{{ mks.id }}">
                                {{ mks.id.length > 23 ? (mks.id | slice: 0 : 23) + '...' : mks.id }}
                            </div>
                        </td>
                        <td>
                            <div class="display-ellipsis" title="{{ mks.name }}">
                                {{ mks.name.length > 40 ? (mks.name | slice: 0 : 40) + '...' : mks.name }}
                            </div>
                        </td>
                        <td>
                            <div class="display-ellipsis" title="{{ mks.visibility }}">
                                {{ mks.visibility.length > 10 ? (mks.visibility | slice: 0 : 10) + '...' : mks.visibility }}
                            </div>
                        </td>
                        <td>
                            <div class="display-ellipsis" title="{{ mks.description }}">
                                {{ mks.description.length > 30 ? (mks.description | slice: 0 : 30) + '...' : mks.description }}
                            </div>
                        </td>
                        <td class="actions-text">
                            <div class="actions-container">
                                <fa-icon
                                    [attr.id]="'toggle-popup-mks'"
                                    [attr.data-test]="'toggle-popup-mks'"
                                    (click)="togglePopup(i, $event)"
                                    class="p-1 cursor-pointer d-flex align-items-center"
                                    [icon]="faEllipsisV"
                                >
                                </fa-icon>
                                <div
                                    *ngIf="activePopupIndex === i"
                                    class="popup-menu-mks"
                                    [ngClass]="{
                                        'popup-menu-mks': !(visibleMksList.length >= 9 && i >= visibleMksList.length - 2),
                                        'popup-menu-bottom-mks': visibleMksList.length >= 9 && i >= visibleMksList.length - 2,
                                    }"
                                >
                                    <div
                                        class="d-flex cursor-pointer popup-container"
                                        [attr.id]="'edit-site-mks'"
                                        [attr.data-test]="'edit-site-mks'"
                                        (click)="editSite(mks, SiteCreateAndEditModel)"
                                    >
                                        <div class="edit-icon"></div>
                                        <div class="popup-item">Edit</div>
                                    </div>
                                    <div
                                        class="d-flex cursor-pointer popup-container"
                                        [attr.id]="'update-user-mks'"
                                        [attr.data-test]="'update-user-mks'"
                                        (click)="editGroup(mks, UpdateUserModal)"
                                    >
                                        <div class="update-user-icon"></div>
                                        <div class="popup-item">Update Users</div>
                                    </div>

                                    <!-- <div class="popup-item" (click)="deleteGroup(group)">Delete</div> -->
                                    <div
                                        class="d-flex cursor-pointer popup-container pb-1"
                                        [attr.id]="'update-usergroup-mks'"
                                        [attr.data-test]="'update-usergroup-mks'"
                                        (click)="OpenupdateUserGroups(mks, UpdateUserGroupsModal)"
                                    >
                                        <div class="update-usergroup-icon"></div>
                                        <div class="popup-item">Update User Groups</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>

                <tr *ngIf="isLoadingData">
                    <td colspan="5" class="text-center text-secondary">
                        <div class="p-1">
                            <div class="d-flex justify-content-center">
                                <div class="padding-summary">Loading..</div>
                                <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="visibleMksList.length === 0 && !isLoadingData">
                    <td colspan="5" class="no-user-text">No Sites available with searched text</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- ............................................create site............................................ -->

    <ng-template #SiteCreateAndEditModel let-modal>
        <div>
            <div class="modal-dialog m-0">
                <div class="modal-content text-center" style="width: 100%; padding: 0px; right: 0px">
                    <div class="modal-header fw-600 create-ug-header">
                        <div *ngIf="!disableForm">Create Site</div>
                        <div *ngIf="disableForm">Edit Site</div>
                        <div class="cursor-pointer btn-close close-form" [attr.id]="'close-site-mks'" [attr.data-test]="'close-site-mks'" (click)="closeCreateandEditForm()"></div>
                    </div>
                    <div class="modal-body ug-form-body">
                        <div class="mb-3">
                            <div class="label-form">Site ID</div>
                            <div class="ug-name-div">
                                <input
                                    type="text"
                                    class="form-control text-box-size shadow-sm ug-name"
                                    placeholder="Enter Site ID"
                                    [attr.id]="'site-id-textbox'"
                                    [attr.data-test]="'site-id-textbox'"
                                    [(ngModel)]="siteID"
                                    [disabled]="disableForm"
                                    (keypress)="restrictInputForID($event)"
                                    (blur)="validateField('siteID')"
                                />
                                <div class="error-message" *ngIf="errors['siteID']">
                                    {{ errors['siteID'] }}
                                </div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <div class="label-form">Site Name</div>
                            <div class="ug-name-div">
                                <input
                                    type="text"
                                    class="form-control text-box-size shadow-sm ug-name"
                                    placeholder="Enter Site Name"
                                    [attr.id]="'site-name-textbox'"
                                    [attr.data-test]="'site-name-textbox'"
                                    [(ngModel)]="sitenameText"
                                    (keypress)="restrictInput($event)"
                                    (blur)="validateField('sitenameText')"
                                />
                                <div class="error-message" *ngIf="errors['sitenameText']">
                                    {{ errors['sitenameText'] }}
                                </div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <div class="label-form">Visibility</div>
                            <div
                                class="select-dropdown"
                                [ngClass]="{ 'select-dropdown-error': errors['selectedVisibility'] }"
                                [attr.id]="'visibility-site-mks'"
                                [attr.data-test]="'visibility-site-mks'"
                            >
                                <select id="userRole" class="form-control ug-form-type" [(ngModel)]="selectedVisibility" (blur)="validateField('selectedVisibility')">
                                    <option value disabled selected>Select</option>
                                    <option class="font-14" *ngFor="let site of siteVisibility" [value]="site">{{ site }}</option>
                                </select>
                                <div class="error-message" *ngIf="errors['selectedVisibility']">
                                    {{ errors['selectedVisibility'] }}
                                </div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <div class="label-form">Description</div>
                            <div class="ug-desc-div">
                                <input
                                    type="text"
                                    class="form-control text-box-size shadow-sm ug-desc-input"
                                    placeholder="Enter Description"
                                    [attr.id]="'decription-textbox'"
                                    [attr.data-test]="'decription-textbox'"
                                    [(ngModel)]="descriptionText"
                                />
                            </div>
                        </div>

                        <div class="mt-3">
                            <div class="d-flex justify-content-end pt-30p">
                                <button
                                    class="float-end create-btn mt-2 d-flex align-items-center justify-content-center"
                                    *ngIf="!disableForm"
                                    [attr.id]="'add-site-mks'"
                                    [attr.data-test]="'add-site-mks'"
                                    (click)="createSite()"
                                    [disabled]="!isFormValid()"
                                >
                                    <span *ngIf="!Loading">Create</span>
                                    <span *ngIf="Loading" class="d-flex align-items-center">
                                        <img class="loading-gif-save me-2" src="../../../assets/gifs/loader_wait.gif" alt="Processing icon" />
                                        <p style="margin: 0">Creating..</p>
                                    </span>
                                </button>
                                <button
                                    class="float-end create-btn mt-2 d-flex align-items-center justify-content-center"
                                    *ngIf="disableForm"
                                    [attr.id]="'update-site-mks'"
                                    [attr.data-test]="'update-site-mks'"
                                    (click)="createSite()"
                                    [disabled]="!isFormValid()"
                                >
                                    <span *ngIf="!Loading">Save</span>
                                    <span *ngIf="Loading" class="d-flex align-items-center">
                                        <img class="loading-gif-save me-2" src="../../../assets/gifs/loader_wait.gif" alt="Processing icon" />
                                        <p style="margin: 0">Saving..</p>
                                    </span>
                                </button>
                                <!-- <button
                                    class="create-btn"
                                    *ngIf="disableForm"
                                    [attr.id]="'update-site-mks'"
                                    [attr.data-test]="'update-site-mks'"
                                    (click)="createSite()"
                                    [disabled]="!isFormValid()"
                                >
                                    Save
                                </button> -->
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <!-- .........................................................update User Modal....................................................... -->

    <ng-template #UpdateUserModal let-modal>
        <!-- <div class="modal-dialog modal-lg">
            <div class="modal-content"> -->
        <div class="modal-header mb-2">
            <div class="mb-1 fw-600">{{ sitename + ' (' + mksid + ')' }} - Users</div>
            <div class="cursor-pointer btn-close close-form" [attr.id]="'close-user-mks'" [attr.data-test]="'close-user-mks'" (click)="closeCreateandEditForm()"></div>
        </div>

        <div class="modal-body ug-form-body">
            <div class="d-flex text-start">
                <div>
                    <div class="fw-500 font-size-1rem">Client Name</div>
                    <app-multi-select-dropdown
                        id="selectedClient"
                        class="multi-select-option form-control shadow-sm multi-select-client"
                        [items]="clientList"
                        [selectedItems]="selectedClientItems"
                        selectedProp="id"
                        displayname="name"
                        [selectedCountText]="selectedClientCountText"
                        [selectedBlankText]="selectedClientBlankText"
                        (selectedItemsChange)="onSelectionClientChange($event)"
                    ></app-multi-select-dropdown>
                </div>
                <div class="margin-client-search">
                    <div class="fw-500 font-size-1rem">User Group</div>
                    <app-multi-select-dropdown
                        id="selectedUserGroup"
                        class="multi-select-option form-control shadow-sm multi-select-client"
                        [items]="userGroupList"
                        selectedProp="userGroupId"
                        [selectedItems]="selectedUserGroupItems"
                        [selectedCountText]="selectedUserGroupCountText"
                        [selectedBlankText]="selectedUserGroupBlankText"
                        (selectedItemsChange)="onSelectionUserGroupChange($event)"
                    ></app-multi-select-dropdown>
                </div>

                <div class="margin-client-search">
                    <div class="d-flex pt-4">
                        <div class="h-30p">
                            <input
                                type="text"
                                class="form-control text-box-size shadow-sm client-search-input"
                                placeholder="Search"
                                [attr.id]="'client-serach-textbox'"
                                [attr.data-test]="'client-serach-textbox'"
                                [(ngModel)]="searchClientName"
                                (input)="onSearchTextChange()"
                                (keyup.enter)="userSearchList()"
                            />
                            <div
                                class="cursor-pointer clear-icon icon-pos"
                                [attr.id]="'clear-client-serach'"
                                [attr.data-test]="'clear-client-serach'"
                                (click)="clearSearchClient()"
                                *ngIf="searchClientName !== ''"
                            ></div>
                        </div>

                        <div class="form-control search-client"></div>

                        <div class="cursor-pointer search-term-icon" [attr.id]="'user-list-serach'" [attr.data-test]="'user-list-serach'" (click)="userSearchList()"></div>
                    </div>
                </div>
            </div>
            <!-- Table Container -->
            <div class="table-container remove-relative d-flex justify-content-center align-items-center">
                <div class="table-wrapper" style="width: 100%">
                    <div [ngClass]="{ 'fixed-container': !isMKSLoadingData }">
                        <!-- Table -->
                        <table class="custom-table table-usergroup" [ngClass]="{ 'custom-table-loading': isMKSLoadingData }">
                            <thead class="custom-table-head">
                                <tr>
                                    <th class="w-5 checkbox-mks-ug">
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="isAllChecked"
                                            [attr.id]="'check-all-users'"
                                            [attr.data-test]="'check-all-users'"
                                            (change)="toggleAllCheckboxes()"
                                        />
                                    </th>
                                    <th class="w-20">Email Id</th>
                                    <th class="w-20">User Name</th>
                                    <th class="w-10">User Group</th>
                                    <th class="w-10">Site Role</th>
                                    <th class="w-5"></th>
                                    <th class="w-5"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="UsersList.length > 0 && !isMKSLoadingData">
                                    <tr *ngFor="let user of UsersList; let i = index">
                                        <td class="w-5 checkbox-mks-ug">
                                            <input
                                                [(ngModel)]="user.isChecked"
                                                (change)="onItemChange(user)"
                                                type="checkbox"
                                                [id]="'checkbox-' + i"
                                                [attr.data-test]="'checkbox-' + i"
                                            />
                                        </td>
                                        <td class="w-20">
                                            <div class="display-ellipsis" title="{{ user.user.emailId }}">
                                                {{ user.user.emailId > 40 ? (user.user.emailId | slice: 0 : 40) + '...' : user.user.emailId }}
                                            </div>
                                        </td>
                                        <td class="w-20">
                                            <div class="display-ellipsis" title="{{ user.user.name }}">
                                                {{ user.user.emailId > 40 ? (user.user.name | slice: 0 : 40) + '...' : user.user.name }}
                                            </div>
                                        </td>
                                        <td class="w-10">
                                            <div class="display-ellipsis" title="{{ user.user.userGroupName }}">
                                                {{ user.user.userGroupName > 30 ? (user.user.userGroupName | slice: 0 : 30) + '...' : user.user.userGroupName }}
                                            </div>
                                        </td>

                                        <td class="w-10">
                                            <div class="select-dropdown d-flex w-100" [attr.id]="'site-role-select' + i" [attr.data-test]="'site-role-select' + i">
                                                <select
                                                    class="form-control u-form-type"
                                                    id="site_role"
                                                    [(ngModel)]="user.siteRole"
                                                    name="site_role"
                                                    required
                                                    #genderField="ngModel"
                                                    placeholder="Select"
                                                    [ngClass]="{ 'highlight-dropdown': user.highlight }"
                                                    [disabled]="user.isPartOfUserGroup"
                                                    [attr.title]="user.isPartOfUserGroup ? 'Cannot change role since user group has access' : ''"
                                                    (change)="onSiteRoleChange(user)"
                                                >
                                                    <option [ngValue]="null" disabled>Select</option>
                                                    <option *ngFor="let role of siteRole" [value]="role">
                                                        {{ role }}
                                                    </option>
                                                </select>
                                            </div>
                                            <!-- <span *ngIf="user.siteRole !== null && user.siteRole !== undefined && !user.isChecked && user.isModified" class="error-message"
                                                >Select respective checkbox</span
                                            > -->
                                        </td>
                                        <td class="w-5">
                                            <button
                                                [ngClass]="{ 'slide-in-user': !user.loading && user.statusCode == 200 }"
                                                class="create-btn d-flex"
                                                *ngIf="user.siteRole !== null && user.isRoleFromAPI && !user.revoked"
                                                [disabled]="user.isPartOfUserGroup"
                                                [attr.title]="user.isPartOfUserGroup ? 'Cannot change role since user group has access' : ''"
                                                (click)="handleRevoke(user)"
                                                [attr.id]="'revoke-user-mks' + i"
                                                [attr.data-test]="'revoke-user-mks' + i"
                                            >
                                                <img
                                                    *ngIf="user.revokeloading"
                                                    [title]="user.error"
                                                    class="loading-gif-revoke"
                                                    src="../../../assets/gifs/loader_wait.gif"
                                                    alt="Processing icon"
                                                />
                                                Revoke
                                            </button>
                                        </td>

                                        <td class="w-5">
                                            <div class="d-flex justify-content-start" *ngIf="user.loading">
                                                <img [title]="user.error" class="loading-gif" src="../../../assets/gifs/loader_wait.gif" alt="Processing icon" />
                                            </div>
                                            <div class="d-flex justify-content-start" *ngIf="user.statusCode === 200 && !user.loading">
                                                <img [title]="user.error" src="../../../assets/user-group/Success.svg" alt="Success icon" />
                                            </div>
                                            <div class="d-flex justify-content-start" *ngIf="user.statusCode !== 200 && user.statusCode != null && !user.loading">
                                                <img [title]="user.error" src="../../../assets/user-group/Failure.svg" alt="Fail icon" />
                                            </div>
                                        </td>
                                        <!-- <td>
                                            <div class="d-flex">
                                                <div class="width-80px">
                                                    <button
                                                        *ngIf="(user.status === undefined || user.status !== 3) && user.siteRole !== null && user.isRoleFromAPI"
                                                        class="create-btn" (click)="onDeleteUser(user)">
                                                        Revoke
                                                    </button>
                                                </div>
                                                <div *ngIf="user.status !== undefined" class="d-flex p-lr-3px">
                                                    <span [title]="user.responseMessage" class="margin-left-4px"
                                                        *ngIf="user.status === 2"><img class="gif-height-width"
                                                            src="../../../assets/Admin_Assets/icon-update-users-success.svg"
                                                            alt="Success icon" /></span>
                                                    <span [title]="user.responseMessage" class="margin-left-4px"
                                                        *ngIf="user.status === 1"><img class="gif-height-width"
                                                            src="../../../assets/gifs/loader_wait.gif"
                                                            alt="Processing icon" /></span>
                                                    <span [title]="user.responseMessage" class="margin-left-4px"
                                                        *ngIf="user.status === 3"><img class="gif-height-width"
                                                            src="../../../assets/Admin_Assets/icon-update-users-failure.svg"
                                                            alt="failure icon" /></span>
                                                </div>
                                            </div>
                                        </td> -->
                                    </tr>
                                </ng-container>
                                <tr *ngIf="isMKSLoadingData">
                                    <td colspan="7" class="text-center text-secondary">
                                        <div class="p-1">
                                            <div class="d-flex justify-content-center">
                                                <div class="padding-summary">Loading..</div>
                                                <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngIf="UsersList?.length === 0 && !isMKSLoadingData">
                                    <td colspan="7" class="no-user-text">No Users available with searched text</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Pagination -->
                    <div *ngIf="UsersList.length > 0" class="mt-2 display-pagination">
                        <div>{{ startItem }} to {{ endItem }} Items of {{ totalItems }}</div>
                        <pagination
                            [totalItems]="totalItems"
                            [(ngModel)]="currentPage"
                            [maxSize]="5"
                            class="justify-content-center pagination mb-0"
                            previousText="&lsaquo;"
                            nextText="&rsaquo;"
                            firstText="&laquo;"
                            lastText="&raquo;"
                            [boundaryLinks]="true"
                            [rotate]="false"
                            (pageChanged)="onPageChanged($event)"
                        ></pagination>
                    </div>
                    <button
                        [disabled]="disableSaveButton || isLoadingData"
                        *ngIf="!isLoadingData && UsersList.length > 0"
                        class="float-end create-btn mt-2 d-flex align-items-center justify-content-center"
                        [disabled]="checkDisableForm()"
                        (click)="SaveUsers()"
                    >
                        <span *ngIf="!Loading">Save</span>
                        <span *ngIf="Loading" class="d-flex align-items-center">
                            <img class="loading-gif-save me-2" src="../../../assets/gifs/loader_wait.gif" alt="Processing icon" />
                            <p style="margin: 0">Saving..</p>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- .........................................................update user groups Modal....................................................... -->

    <ng-template #UpdateUserGroupsModal let-modal>
        <div class="modal-header mb-2">
            <div class="mb-1 fw-600">{{ siteName + ' (' + siteID + ')' }} - User Groups</div>
            <div class="cursor-pointer btn-close close-form" [attr.id]="'close-usergroup-mks'" [attr.data-test]="'close-usergroup-mks'" (click)="closeUserGroupModal()"></div>
        </div>

        <div class="modal-body ug-form-body">
            <!-- Table Container -->
            <div class="d-flex text-start">
                <div>
                    <div class="fw-500 font-size-1rem">Client Name</div>
                    <app-multi-select-dropdown
                        id="selectedClient"
                        class="multi-select-option form-control shadow-sm multi-select-client"
                        [items]="clientList"
                        [selectedItems]="selectedClientItems"
                        displayname="name"
                        selectedProp="id"
                        [selectedCountText]="selectedClientCountText"
                        [selectedBlankText]="selectedClientBlankText"
                        (selectedItemsChange)="onSelectionClientChange($event)"
                        (resetDataOnclear)="onClearSelectedClient($event)"
                    ></app-multi-select-dropdown>
                </div>
                <div class="margin-client-search">
                    <div class="d-flex pt-4">
                        <div class="h-30p">
                            <input
                                type="text"
                                class="form-control text-box-size shadow-sm client-search-input"
                                placeholder="Search"
                                [attr.id]="'gyan-client-textbox'"
                                [attr.data-test]="'gyan-client-textbox'"
                                [(ngModel)]="searchUserGroupName"
                                (input)="onSearchTextChangeUserGroup()"
                                (keyup.enter)="getUserGroupsBySite()"
                            />
                            <div
                                class="cursor-pointer clear-icon icon-pos"
                                *ngIf="searchUserGroupName !== ''"
                                [attr.id]="'clear-usergroup-mks'"
                                [attr.data-test]="'clear-usergroup-mks'"
                                (click)="clearSearchUserGroup()"
                            ></div>
                        </div>

                        <div class="form-control search-client"></div>

                        <div
                            class="cursor-pointer search-term-icon"
                            [attr.id]="'search-usergroup-mks'"
                            [attr.data-test]="'search-usergroup-mks'"
                            (click)="getUserGroupsBySite()"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="table-container remove-relative d-flex justify-content-center align-items-center">
                <div class="table-wrapper" style="width: 100%">
                    <!-- Table -->
                    <div class="" [ngClass]="{ 'fixed-container': !isLoadingDataUserGroup }">
                        <table class="custom-table table-usergroup" [ngClass]="{ 'custom-table-loading': isLoadingDataUserGroup }">
                            <thead class="custom-table-head">
                                <tr>
                                    <th class="w-5 checkbox-mks-ug">
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="isAllCheckedUsergroup"
                                            [attr.id]="'check-all-usergroups'"
                                            [attr.data-test]="'check-all-usergroups'"
                                            (change)="checkAllUserGroup()"
                                        />
                                    </th>
                                    <th class="w-25">User Group Name</th>
                                    <th class="w-25">User Group Label</th>
                                    <th class="w-10">Site Role</th>
                                    <th class="w-5"></th>
                                    <th class="w-5"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="siteUserGroupsList?.length > 0 && !isLoadingDataUserGroup">
                                    <tr *ngFor="let group of siteUserGroupsList; let i = index" class="h-35p">
                                        <!-- <td>
                                            <input type="checkbox" [id]="'checkbox-' + i" />
                                        </td> -->
                                        <td class="w-5 checkbox-mks-ug">
                                            <input
                                                [(ngModel)]="group.isChecked"
                                                (change)="onItemChangeUserGroup(group)"
                                                type="checkbox"
                                                [id]="'checkbox-' + i"
                                                [attr.data-test]="'checkbox-' + i"
                                            />
                                        </td>
                                        <td class="w-25">
                                            <div class="display-ellipsis" title="{{ group.details.name }}">{{ group.details.name }}</div>
                                        </td>
                                        <td class="w-25">
                                            <div class="display-ellipsis" title="{{ group.details.label }}">{{ group.details.label }}</div>
                                        </td>
                                        <td class="w-10">
                                            <div class="select-dropdown d-flex w-100" [attr.id]="'site-role-usergroups' + i" [attr.data-test]="'site-role-usergroups' + i">
                                                <select
                                                    id="siteRole"
                                                    class="form-control ug-form-type"
                                                    [(ngModel)]="group.siteRole"
                                                    name="site_role"
                                                    required
                                                    #genderField="ngModel"
                                                    placeholder="Select"
                                                    [ngClass]="{ 'highlight-dropdown': group.highlight }"
                                                    (change)="onSiteRoleChangeUserGroup(group)"
                                                >
                                                    <option [ngValue]="null" disabled>Select</option>
                                                    <option *ngFor="let role of siteRole" [value]="role">
                                                        {{ role }}
                                                    </option>
                                                    <!-- <option class="font-14" *ngFor="let role of roles" [value]="role">{{ role }}</option> -->
                                                </select>
                                            </div>
                                        </td>
                                        <td class="w-5" [attr.id]="'revoke-usergroups' + i" [attr.data-test]="'revoke-usergroups' + i">
                                            <button
                                                [ngClass]="{ 'slide-in': !group.loading && group.statusCode == 200 }"
                                                class="create-btn d-flex"
                                                *ngIf="group.siteRole !== null && group.siteRoleExist && !group.revoked"
                                                (click)="revokeUserGroup(group)"
                                            >
                                                <img
                                                    *ngIf="group.revokeloading"
                                                    [title]="group.error"
                                                    class="loading-gif-revoke"
                                                    src="../../../assets/gifs/loader_wait.gif"
                                                    alt="Processing icon"
                                                />
                                                Revoke
                                            </button>
                                        </td>
                                        <td class="w-5">
                                            <div class="d-flex justify-content-start" *ngIf="group.loading">
                                                <img [title]="group.error" class="loading-gif" src="../../../assets/gifs/loader_wait.gif" alt="Processing icon" />
                                            </div>
                                            <div class="d-flex justify-content-start" *ngIf="group.statusCode === 200 && !group.loading">
                                                <img [title]="group.error" src="../../../assets/user-group/Success.svg" alt="Success icon" />
                                            </div>
                                            <div class="d-flex justify-content-start" *ngIf="group.statusCode !== 200 && group.statusCode != null && !group.loading">
                                                <img [title]="group.error" src="../../../assets/user-group/Failure.svg" alt="Fail icon" />
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr *ngIf="siteUserGroupsList?.length === 0 || siteUserGroupsList === null">
                                    <td colspan="6" class="no-user-text">No User groups available with searched text</td>
                                </tr>
                                <tr *ngIf="isLoadingDataUserGroup">
                                    <td colspan="6" class="text-center text-secondary">
                                        <div class="p-1">
                                            <div class="d-flex justify-content-center">
                                                <div class="padding-summary">Loading..</div>
                                                <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Pagination -->
                    <div *ngIf="siteUserGroupsList?.length > 0" class="display-pagination mt-3">
                        <div>{{ startItem }} to {{ endItem }} Items of {{ totalItems }}</div>
                        <pagination
                            [totalItems]="totalItems"
                            [(ngModel)]="currentPage"
                            [maxSize]="5"
                            class="justify-content-center pagination mb-0"
                            previousText="&lsaquo;"
                            nextText="&rsaquo;"
                            firstText="&laquo;"
                            lastText="&raquo;"
                            [boundaryLinks]="true"
                            [rotate]="false"
                            (pageChanged)="onPageChangedUserGroup($event)"
                        ></pagination>
                    </div>

                    <div class="d-flex justify-content-end mt-2" [attr.id]="'save-usergroups'" [attr.data-test]="'save-usergroups'">
                        <!-- <button
                        [disabled]="disableSaveButton || isLoadingData"
                         *ngIf="!isLoadingData && userGroupList.length > 0" class="float-end create-btn mt-2" style="width: 90px" [disabled]="checkDisableFormUserGroup()" (click)="saveUserGroups()">
                            <span *ngIf="!Loading">Save</span>
                            <span style="display: flex" *ngIf="Loading">
                                <img style="width: 15px !important; height: 15px !important; margin: auto" src="./../assets/gifs/loader_sand.gif" alt="Processing icon" />
                                <p style="margin: auto">Saving..</p>
                            </span>
                        </button> -->
                        <button
                            [disabled]="disableSaveButton || Loading"
                            class="float-end create-btn mt-2 d-flex align-items-center justify-content-center"
                            [disabled]="checkDisableFormUserGroup()"
                            *ngIf="siteUserGroupsList?.length > 0"
                            (click)="saveUserGroups()"
                        >
                            <span *ngIf="!Loading">Save</span>
                            <span class="d-flex align-items-center" *ngIf="Loading">
                                <img class="loading-gif-save me-2" src="../../../assets/gifs/loader_wait.gif" alt="Processing icon" />
                                <p style="margin: 0">Saving..</p>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
